import React, { createContext, useContext, useState } from 'react';

// Create the ModalContext
const ModalContext = createContext();

// Custom hook to use the ModalContext
export const useModal = () => useContext(ModalContext);

// ModalProvider component to wrap the app
export const ModalProvider = ({ children }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <ModalContext.Provider value={{ isModalOpen, openModal, closeModal }}>
            {children}
        </ModalContext.Provider>
    );
};
